import * as Yup from 'yup';

export const flaggedKitsSchema = Yup.object({
  kitNo: Yup.string().required('Kit# is required'),
});
